var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticStyle: { position: "relative" } },
    [
      _c("v-card", { attrs: { flat: "" } }, [
        _c("div", { attrs: { id: "controlsContainer" } }, [
          _c(
            "div",
            {
              staticClass:
                "card-title table-controls px-3 d-flex align-center justify-space-between"
            },
            [
              _c(
                "div",
                [
                  _vm.$checkPermission("CLIENTS")
                    ? _c("crud-button", {
                        attrs: {
                          "x-large": "",
                          color: "light-blue lighten-2",
                          icon: "fa-plus",
                          tooltip: _vm.$t("global.crud.button.add")
                        },
                        on: {
                          clicked: function($event) {
                            return _vm.create()
                          }
                        }
                      })
                    : _vm._e()
                ],
                1
              ),
              _c(
                "div",
                [
                  _c(
                    "v-container",
                    { attrs: { id: "filterContainer" } },
                    [
                      _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            { attrs: { lg: "3", sm: "12", cols: "12" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: _vm.$t("global.datatable.search"),
                                  "append-icon": "fas fa-search",
                                  "single-line": ""
                                },
                                model: {
                                  value: _vm.filter.allFields,
                                  callback: function($$v) {
                                    _vm.$set(_vm.filter, "allFields", $$v)
                                  },
                                  expression: "filter.allFields"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { lg: "2", sm: "6", cols: "12" } },
                            [
                              _c("v-select", {
                                attrs: {
                                  items: _vm.deletedItemsValues,
                                  label: _vm.$t("global.status")
                                },
                                model: {
                                  value: _vm.filter.deletedItems,
                                  callback: function($$v) {
                                    _vm.$set(_vm.filter, "deletedItems", $$v)
                                  },
                                  expression: "filter.deletedItems"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { lg: "2", sm: "6", cols: "12" } },
                            [
                              _c("v-select", {
                                attrs: {
                                  items: _vm.autoschedulingValues,
                                  label: _vm.$t("clients.autoscheduling")
                                },
                                model: {
                                  value: _vm.filter.autoscheduling,
                                  callback: function($$v) {
                                    _vm.$set(_vm.filter, "autoscheduling", $$v)
                                  },
                                  expression: "filter.autoscheduling"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { lg: "2", sm: "6", cols: "12" } },
                            [
                              _c(
                                "v-dialog",
                                {
                                  ref:
                                    "dialogFilterAutoschedulingCutOffTimeFrom",
                                  attrs: {
                                    "return-value":
                                      _vm.filter
                                        .autoschedulingCutOffTimeFromString,
                                    persistent: "",
                                    width: "290px"
                                  },
                                  on: {
                                    "update:returnValue": function($event) {
                                      return _vm.$set(
                                        _vm.filter,
                                        "autoschedulingCutOffTimeFromString",
                                        $event
                                      )
                                    },
                                    "update:return-value": function($event) {
                                      return _vm.$set(
                                        _vm.filter,
                                        "autoschedulingCutOffTimeFromString",
                                        $event
                                      )
                                    }
                                  },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "activator",
                                      fn: function({ on }) {
                                        return [
                                          _c(
                                            "v-text-field",
                                            _vm._g(
                                              {
                                                attrs: {
                                                  label: _vm.$t(
                                                    "clients.autoschedulingCutOffTimeFrom"
                                                  ),
                                                  readonly: "",
                                                  clearable: "",
                                                  "append-icon": "far fa-clock"
                                                },
                                                model: {
                                                  value:
                                                    _vm.filter
                                                      .autoschedulingCutOffTimeFromString,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.filter,
                                                      "autoschedulingCutOffTimeFromString",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "filter.autoschedulingCutOffTimeFromString"
                                                }
                                              },
                                              on
                                            )
                                          )
                                        ]
                                      }
                                    }
                                  ]),
                                  model: {
                                    value:
                                      _vm.modalFilterAutoschedulingCutOffTimeFrom,
                                    callback: function($$v) {
                                      _vm.modalFilterAutoschedulingCutOffTimeFrom = $$v
                                    },
                                    expression:
                                      "modalFilterAutoschedulingCutOffTimeFrom"
                                  }
                                },
                                [
                                  _vm.modalFilterAutoschedulingCutOffTimeFrom
                                    ? _c(
                                        "v-time-picker",
                                        {
                                          attrs: {
                                            "full-width": "",
                                            format: "24hr",
                                            "allowed-minutes":
                                              _vm.allowedStepTime
                                          },
                                          on: {
                                            "click:minute": function($event) {
                                              return _vm.$refs.dialogFilterAutoschedulingCutOffTimeFrom.save(
                                                _vm.filter
                                                  .autoschedulingCutOffTimeFromString
                                              )
                                            }
                                          },
                                          model: {
                                            value:
                                              _vm.filter
                                                .autoschedulingCutOffTimeFromString,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.filter,
                                                "autoschedulingCutOffTimeFromString",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "filter.autoschedulingCutOffTimeFromString"
                                          }
                                        },
                                        [
                                          _c("v-spacer"),
                                          _c(
                                            "v-btn",
                                            {
                                              attrs: {
                                                text: "",
                                                color: "primary"
                                              },
                                              on: {
                                                click: function($event) {
                                                  _vm.modalFilterAutoschedulingCutOffTimeFrom = false
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$t("global.cancel")
                                                  ) +
                                                  " "
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { lg: "2", sm: "6", cols: "12" } },
                            [
                              _c(
                                "v-dialog",
                                {
                                  ref: "dialogFilterAutoschedulingCutOffTimeTo",
                                  attrs: {
                                    "return-value":
                                      _vm.filter
                                        .autoschedulingCutOffTimeToString,
                                    persistent: "",
                                    width: "290px"
                                  },
                                  on: {
                                    "update:returnValue": function($event) {
                                      return _vm.$set(
                                        _vm.filter,
                                        "autoschedulingCutOffTimeToString",
                                        $event
                                      )
                                    },
                                    "update:return-value": function($event) {
                                      return _vm.$set(
                                        _vm.filter,
                                        "autoschedulingCutOffTimeToString",
                                        $event
                                      )
                                    }
                                  },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "activator",
                                      fn: function({ on }) {
                                        return [
                                          _c(
                                            "v-text-field",
                                            _vm._g(
                                              {
                                                attrs: {
                                                  label: _vm.$t(
                                                    "clients.autoschedulingCutOffTimeTo"
                                                  ),
                                                  readonly: "",
                                                  clearable: "",
                                                  "append-icon": "far fa-clock"
                                                },
                                                model: {
                                                  value:
                                                    _vm.filter
                                                      .autoschedulingCutOffTimeToString,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.filter,
                                                      "autoschedulingCutOffTimeToString",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "filter.autoschedulingCutOffTimeToString"
                                                }
                                              },
                                              on
                                            )
                                          )
                                        ]
                                      }
                                    }
                                  ]),
                                  model: {
                                    value:
                                      _vm.modalFilterAutoschedulingCutOffTimeTo,
                                    callback: function($$v) {
                                      _vm.modalFilterAutoschedulingCutOffTimeTo = $$v
                                    },
                                    expression:
                                      "modalFilterAutoschedulingCutOffTimeTo"
                                  }
                                },
                                [
                                  _vm.modalFilterAutoschedulingCutOffTimeTo
                                    ? _c(
                                        "v-time-picker",
                                        {
                                          attrs: {
                                            "full-width": "",
                                            format: "24hr",
                                            "allowed-minutes":
                                              _vm.allowedStepTime
                                          },
                                          on: {
                                            "click:minute": function($event) {
                                              return _vm.$refs.dialogFilterAutoschedulingCutOffTimeTo.save(
                                                _vm.filter
                                                  .autoschedulingCutOffTimeToString
                                              )
                                            }
                                          },
                                          model: {
                                            value:
                                              _vm.filter
                                                .autoschedulingCutOffTimeToString,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.filter,
                                                "autoschedulingCutOffTimeToString",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "filter.autoschedulingCutOffTimeToString"
                                          }
                                        },
                                        [
                                          _c("v-spacer"),
                                          _c(
                                            "v-btn",
                                            {
                                              attrs: {
                                                text: "",
                                                color: "primary"
                                              },
                                              on: {
                                                click: function($event) {
                                                  _vm.modalFilterAutoschedulingCutOffTimeTo = false
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$t("global.cancel")
                                                  ) +
                                                  " "
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                [
                  _c("crud-button", {
                    attrs: {
                      large: "",
                      color: "blue",
                      icon: "fa-sync-alt",
                      tooltip: _vm.$t("global.crud.buttons.refreshTable")
                    },
                    on: {
                      clicked: function($event) {
                        return _vm.refreshItemsView()
                      }
                    }
                  }),
                  _c("ExportExcel", {
                    attrs: { url: "/clients", filter: this.filter }
                  }),
                  _vm.$checkPermission("CLIENTS")
                    ? _c("ImportExcel", {
                        attrs: { url: "/clients" },
                        on: { done: _vm.search }
                      })
                    : _vm._e()
                ],
                1
              )
            ]
          )
        ]),
        _c(
          "div",
          { attrs: { id: "dataContainer" } },
          [
            _c("v-data-table", {
              attrs: {
                headers: _vm.headers,
                items: _vm.items,
                "item-key": "code",
                options: _vm.options,
                page: _vm.pagination.page,
                "server-items-length": _vm.pagination.totalItems,
                "no-results-text": _vm.$t("global.datatable.noMatchingResults"),
                "no-data-text": _vm.$t("global.datatable.noDataAvailable"),
                "footer-props": {
                  "items-per-page-options": _vm.rowsPerPageItems,
                  "show-first-last-page": true,
                  "show-current-page": true
                },
                loading: _vm.loading,
                light: "",
                "multi-sort": "",
                dense: ""
              },
              on: {
                "update:options": function($event) {
                  _vm.options = $event
                },
                "update:page": function($event) {
                  return _vm.$set(_vm.pagination, "page", $event)
                }
              },
              scopedSlots: _vm._u([
                {
                  key: "body",
                  fn: function({ items }) {
                    return [
                      _c(
                        "tbody",
                        _vm._l(items, function(item) {
                          return _c("tr", { key: item.code }, [
                            _c(
                              "td",
                              [
                                _vm.$checkPermission("CLIENTS")
                                  ? _c("crud-button", {
                                      attrs: {
                                        "x-small": "",
                                        color: "orange",
                                        icon: "fa-pen",
                                        tooltip: _vm.$t(
                                          "global.crud.buttons.edit"
                                        )
                                      },
                                      on: {
                                        clicked: function($event) {
                                          return _vm.edit(item.code)
                                        }
                                      }
                                    })
                                  : _vm._e(),
                                (item.deletionDate === undefined ||
                                  item.deletionDate === null) &&
                                _vm.$checkPermission("CLIENTS")
                                  ? _c("crud-button", {
                                      attrs: {
                                        "x-small": "",
                                        color: "red",
                                        icon: "fa-trash",
                                        tooltip: _vm.$t(
                                          "global.crud.buttons.delete"
                                        )
                                      },
                                      on: {
                                        clicked: function($event) {
                                          return _vm.suspend(item.code)
                                        }
                                      }
                                    })
                                  : _vm.$checkPermission("CLIENTS")
                                  ? _c("crud-button", {
                                      attrs: {
                                        "x-small": "",
                                        color: "green",
                                        icon: "fa-redo",
                                        tooltip: _vm.$t(
                                          "global.crud.buttons.restore"
                                        )
                                      },
                                      on: {
                                        clicked: function($event) {
                                          return _vm.restore(item.code)
                                        }
                                      }
                                    })
                                  : _vm._e(),
                                _vm.$checkPermission("TIMESLOTSCLIENTS")
                                  ? _c("crud-button", {
                                      attrs: {
                                        "x-small": "",
                                        color: "blue accent-3",
                                        icon: "fa-business-time",
                                        tooltip: _vm.$t(
                                          "clients.timeSlots.button.title"
                                        )
                                      },
                                      on: {
                                        clicked: function($event) {
                                          return _vm.timeSlotsClients(item.code)
                                        }
                                      }
                                    })
                                  : _vm._e()
                              ],
                              1
                            ),
                            _c("td", [_vm._v(" " + _vm._s(item.code) + " ")]),
                            _c("td", [_vm._v(" " + _vm._s(item.name) + " ")]),
                            _c(
                              "td",
                              [
                                _c("BooleanToIcon", {
                                  attrs: { value: item.autoscheduling }
                                })
                              ],
                              1
                            ),
                            _c(
                              "td",
                              [
                                _c("BooleanToIcon", {
                                  attrs: { value: item.autoschedulingRespect }
                                })
                              ],
                              1
                            ),
                            _c("td", [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.minutesToHour(
                                      item.autoschedulingCutOffTime
                                    )
                                  ) +
                                  " "
                              )
                            ])
                          ])
                        }),
                        0
                      )
                    ]
                  }
                }
              ])
            })
          ],
          1
        )
      ]),
      _c(
        "v-dialog",
        {
          attrs: {
            "max-width": "600",
            persistent: "",
            "no-click-animation": ""
          },
          model: {
            value: _vm.dialog,
            callback: function($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog"
          }
        },
        [
          _c("validation-observer", {
            ref: "obs",
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function({ invalid, validated, passes }) {
                  return [
                    _c(
                      "v-card",
                      [
                        _c(
                          "v-toolbar",
                          {
                            attrs: {
                              dark: "",
                              color: "primary",
                              dense: "",
                              flat: ""
                            }
                          },
                          [
                            _c(
                              "v-toolbar-title",
                              { staticClass: "white--text" },
                              [_vm._v(" " + _vm._s(_vm.formTitle) + " ")]
                            ),
                            _c("v-spacer"),
                            _c(
                              "v-btn",
                              {
                                attrs: { icon: "" },
                                nativeOn: {
                                  click: function($event) {
                                    return _vm.close()
                                  }
                                }
                              },
                              [_c("v-icon", [_vm._v("fas fa-times")])],
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "v-card-text",
                          { staticClass: "details-list" },
                          [
                            _c(
                              "v-form",
                              [
                                _c(
                                  "v-layout",
                                  { attrs: { row: "", wrap: "" } },
                                  [
                                    _c(
                                      "v-flex",
                                      { staticClass: "sm12" },
                                      [
                                        _c("validation-provider", {
                                          attrs: {
                                            name: _vm.$t("clients.code"),
                                            rules: "required|max:30"
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function({ errors }) {
                                                  return [
                                                    _c("v-text-field", {
                                                      attrs: {
                                                        label: _vm.$t(
                                                          "clients.code"
                                                        ),
                                                        disabled: _vm.editMode,
                                                        required: "",
                                                        "error-messages": errors,
                                                        counter: "30"
                                                      },
                                                      model: {
                                                        value: _vm.item.code,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.item,
                                                            "code",
                                                            $$v
                                                          )
                                                        },
                                                        expression: "item.code"
                                                      }
                                                    })
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            true
                                          )
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _c(
                                  "v-layout",
                                  { attrs: { row: "", wrap: "" } },
                                  [
                                    _c(
                                      "v-flex",
                                      { staticClass: "sm12" },
                                      [
                                        _c("validation-provider", {
                                          attrs: {
                                            name: _vm.$t("clients.name"),
                                            rules: "required|max:60"
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function({ errors }) {
                                                  return [
                                                    _c("v-text-field", {
                                                      attrs: {
                                                        label: _vm.$t(
                                                          "clients.name"
                                                        ),
                                                        required: "",
                                                        "error-messages": errors,
                                                        counter: "60"
                                                      },
                                                      model: {
                                                        value: _vm.item.name,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.item,
                                                            "name",
                                                            $$v
                                                          )
                                                        },
                                                        expression: "item.name"
                                                      }
                                                    })
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            true
                                          )
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _c(
                                  "v-layout",
                                  { attrs: { row: "", wrap: "" } },
                                  [
                                    _c(
                                      "v-row",
                                      { attrs: { "no-gutters": "" } },
                                      [
                                        _c(
                                          "v-col",
                                          {
                                            staticClass:
                                              "d-inline-flex align-self-center"
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "clients.autoscheduling"
                                                  )
                                                ) +
                                                " "
                                            )
                                          ]
                                        ),
                                        _c(
                                          "v-col",
                                          {
                                            staticClass:
                                              "d-inline-flex justify-end"
                                          },
                                          [
                                            _c("v-switch", {
                                              staticClass: "ml-2",
                                              model: {
                                                value: _vm.item.autoscheduling,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.item,
                                                    "autoscheduling",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "item.autoscheduling"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _c(
                                  "v-layout",
                                  { attrs: { row: "", wrap: "" } },
                                  [
                                    _c(
                                      "v-row",
                                      { attrs: { "no-gutters": "" } },
                                      [
                                        _c(
                                          "v-col",
                                          {
                                            staticClass:
                                              "d-inline-flex align-self-center"
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "clients.autoschedulingRespect"
                                                  )
                                                ) +
                                                " "
                                            )
                                          ]
                                        ),
                                        _c(
                                          "v-col",
                                          {
                                            staticClass:
                                              "d-inline-flex justify-end"
                                          },
                                          [
                                            _c("v-switch", {
                                              staticClass: "ml-2",
                                              model: {
                                                value:
                                                  _vm.item
                                                    .autoschedulingRespect,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.item,
                                                    "autoschedulingRespect",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "item.autoschedulingRespect"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _c(
                                  "v-layout",
                                  { attrs: { row: "", wrap: "" } },
                                  [
                                    _c(
                                      "v-flex",
                                      { staticClass: "sm12" },
                                      [
                                        _c(
                                          "v-dialog",
                                          {
                                            ref:
                                              "dialogAutoschedulingCutOffTime",
                                            attrs: {
                                              "return-value":
                                                _vm.item
                                                  .autoschedulingCutOffTimeString,
                                              persistent: "",
                                              width: "290px"
                                            },
                                            on: {
                                              "update:returnValue": function(
                                                $event
                                              ) {
                                                return _vm.$set(
                                                  _vm.item,
                                                  "autoschedulingCutOffTimeString",
                                                  $event
                                                )
                                              },
                                              "update:return-value": function(
                                                $event
                                              ) {
                                                return _vm.$set(
                                                  _vm.item,
                                                  "autoschedulingCutOffTimeString",
                                                  $event
                                                )
                                              }
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "activator",
                                                  fn: function({ on }) {
                                                    return [
                                                      _c(
                                                        "validation-provider",
                                                        {
                                                          attrs: {
                                                            name: _vm.$t(
                                                              "clients.autoschedulingCutOffTime"
                                                            ),
                                                            vid:
                                                              "fieldAutoschedulingCutOffTime"
                                                          },
                                                          scopedSlots: _vm._u(
                                                            [
                                                              {
                                                                key: "default",
                                                                fn: function({
                                                                  errors
                                                                }) {
                                                                  return [
                                                                    _c(
                                                                      "v-text-field",
                                                                      _vm._g(
                                                                        {
                                                                          attrs: {
                                                                            label: _vm.$t(
                                                                              "clients.autoschedulingCutOffTime"
                                                                            ),
                                                                            readonly:
                                                                              "",
                                                                            clearable:
                                                                              "",
                                                                            "append-icon":
                                                                              "far fa-clock",
                                                                            "error-messages": errors
                                                                          },
                                                                          model: {
                                                                            value:
                                                                              _vm
                                                                                .item
                                                                                .autoschedulingCutOffTimeString,
                                                                            callback: function(
                                                                              $$v
                                                                            ) {
                                                                              _vm.$set(
                                                                                _vm.item,
                                                                                "autoschedulingCutOffTimeString",
                                                                                $$v
                                                                              )
                                                                            },
                                                                            expression:
                                                                              "item.autoschedulingCutOffTimeString"
                                                                          }
                                                                        },
                                                                        on
                                                                      )
                                                                    )
                                                                  ]
                                                                }
                                                              }
                                                            ],
                                                            null,
                                                            true
                                                          )
                                                        }
                                                      )
                                                    ]
                                                  }
                                                }
                                              ],
                                              null,
                                              true
                                            ),
                                            model: {
                                              value:
                                                _vm.modalAutoschedulingCutOffTime,
                                              callback: function($$v) {
                                                _vm.modalAutoschedulingCutOffTime = $$v
                                              },
                                              expression:
                                                "modalAutoschedulingCutOffTime"
                                            }
                                          },
                                          [
                                            _vm.modalAutoschedulingCutOffTime
                                              ? _c(
                                                  "v-time-picker",
                                                  {
                                                    attrs: {
                                                      "full-width": "",
                                                      format: "24hr",
                                                      "allowed-minutes":
                                                        _vm.allowedStepTime
                                                    },
                                                    on: {
                                                      "click:minute": function(
                                                        $event
                                                      ) {
                                                        return _vm.$refs.dialogAutoschedulingCutOffTime.save(
                                                          _vm.item
                                                            .autoschedulingCutOffTimeString
                                                        )
                                                      }
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.item
                                                          .autoschedulingCutOffTimeString,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.item,
                                                          "autoschedulingCutOffTimeString",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "item.autoschedulingCutOffTimeString"
                                                    }
                                                  },
                                                  [
                                                    _c("v-spacer"),
                                                    _c(
                                                      "v-btn",
                                                      {
                                                        attrs: {
                                                          text: "",
                                                          color: "primary"
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            _vm.modalAutoschedulingCutOffTime = false
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.$t(
                                                                "global.cancel"
                                                              )
                                                            ) +
                                                            " "
                                                        )
                                                      ]
                                                    ),
                                                    _c(
                                                      "v-btn",
                                                      {
                                                        attrs: {
                                                          text: "",
                                                          color: "primary"
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.$refs.dialogAutoschedulingCutOffTime.save(
                                                              _vm.item
                                                                .autoschedulingCutOffTimeString
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.$t(
                                                                "global.confirm"
                                                              )
                                                            ) +
                                                            " "
                                                        )
                                                      ]
                                                    )
                                                  ],
                                                  1
                                                )
                                              : _vm._e()
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "v-card-actions",
                          [
                            _c("v-spacer"),
                            _c(
                              "v-btn",
                              {
                                attrs: { color: "black", text: "" },
                                nativeOn: {
                                  click: function($event) {
                                    return _vm.close()
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t("global.buttons.close")) +
                                    " "
                                )
                              ]
                            ),
                            _vm.editMode
                              ? _c(
                                  "v-btn",
                                  {
                                    attrs: { color: "orange", text: "" },
                                    on: {
                                      click: function($event) {
                                        return passes(_vm.update)
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t("global.buttons.update")
                                        ) +
                                        " "
                                    )
                                  ]
                                )
                              : _c(
                                  "v-btn",
                                  {
                                    attrs: { color: "green", text: "" },
                                    on: {
                                      click: function($event) {
                                        return passes(_vm.save)
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t("global.buttons.create")
                                        ) +
                                        " "
                                    )
                                  ]
                                )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }